import useTheme from "Hooks/useTheme";

export default function useCompanyLogos() {
    const s3LogoUrl =
        "https://dimension-company-logos.s3.us-west-2.amazonaws.com";

    const defaultImage = `${s3LogoUrl}/dimension`;

    const { theme } = useTheme();

    /** Falls back to light logo if dark variant doesn't exist, then to default */
    const onImageError = (e: any) => {
        const src: string = e.target.src.split("?")[0];
        if (src.endsWith("-dark")) {
            // Dark variant not found — try the light logo
            e.target.src = src.replace(/-dark$/, "") + `?t=${Date.now()}`;
        } else {
            e.target.src = defaultImage;
        }
    };

    const getLogo = (companyId: string) => {
        const key = theme === "dark" ? `${companyId}-dark` : companyId;
        return `${s3LogoUrl}/${key}`;
    };

    return {
        onImageError,
        getLogo,
    };
}
